import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { License, PretreatmentType } from '@workspace-app/odatabackend/QualicoatBackendModel';

export interface NextLicenseNumberResponse {
  nextNumber: number;
  licenseType: string;
  prefix: string;
  formattedNumber: string;
  usesDynamicPrefix: boolean;
}

export interface CheckLicenseNumberResponse {
  exists: boolean;
  prefix: string;
  formattedNumber: string;
  usesDynamicPrefix: boolean;
}

export interface LineExtensionDto {
  lineId: string;
  designation: string;
  pretreatment: PretreatmentType | null;
  seaside: boolean;
  postforming: boolean;
}

export interface CreateLicenseDto {
  licenseType: string;
  isGranting?: boolean;
  number?: number;
  productionSiteId?: string;
  issueDate?: string; // ISO date string (not required for granting licenses)
  expiryDate?: string; // ISO date string (not required for granting licenses)
  firstCertificationYear?: number;
  grantingNumber?: number;
  lineExtensions?: LineExtensionDto[];
}

@Injectable({
  providedIn: 'root',
})
export class LicenseNumberDataService {
  private httpClient = inject(HttpClient);

  /**
   * Get the next available license number for a given license type
   */
  getNextLicenseNumber(licenseType: string) {
    return this.httpClient.get<NextLicenseNumberResponse>('api/licenses/next-number', {
      params: { licenseType }
    });
  }

  /**
   * Check if a license number already exists for a given license type
   */
  checkNumberExists(licenseType: string, number: number) {
    return this.httpClient.get<CheckLicenseNumberResponse>('api/licenses/check-number', {
      params: { licenseType, number: number.toString() }
    });
  }

  /**
   * Create a new license
   */
  createLicense(dto: CreateLicenseDto) {
    return this.httpClient.post<License>('api/licenses', dto);
  }
}
